import { render, staticRenderFns } from "./winCourse.vue?vue&type=template&id=9e22b092&scoped=true"
import script from "./winCourse.vue?vue&type=script&lang=js"
export * from "./winCourse.vue?vue&type=script&lang=js"
import style0 from "./winCourse.vue?vue&type=style&index=0&id=9e22b092&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e22b092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e22b092')) {
      api.createRecord('9e22b092', component.options)
    } else {
      api.reload('9e22b092', component.options)
    }
    module.hot.accept("./winCourse.vue?vue&type=template&id=9e22b092&scoped=true", function () {
      api.rerender('9e22b092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/winCourse.vue"
export default component.exports